import { render } from "./datasets.vue?vue&type=template&id=f3ede8f0"
import script from "./datasets.vue?vue&type=script&lang=js"
export * from "./datasets.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__